var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5423_21321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 6.50062L10.6115 8.24162C10.6491 8.26667 10.6929 8.28105 10.7381 8.28321C10.7832 8.28537 10.8281 8.27524 10.868 8.25389C10.9079 8.23255 10.9412 8.20079 10.9644 8.162C10.9877 8.12321 11 8.07884 11 8.03362V3.93562C11 3.89163 10.9884 3.84842 10.9664 3.81034C10.9444 3.77227 10.9127 3.74068 10.8745 3.71877C10.8364 3.69686 10.7931 3.6854 10.7492 3.68555C10.7052 3.6857 10.662 3.69745 10.624 3.71962L8 5.25062",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3H2C1.44772 3 1 3.44772 1 4V8C1 8.55228 1.44772 9 2 9H7C7.55228 9 8 8.55228 8 8V4C8 3.44772 7.55228 3 7 3Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5423_21321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a4060eb47c3816f05929ba86f03f657d.svg";
export { ForwardRef as ReactComponent };